import { axiosInstanceV2 } from "@src/shared/api";
import { PAYMENTS_API_URL } from "../constants";
import { createTariffResponseDto } from "../interfaces/createTariffResponseDto";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

interface createTariffRequestDto {
  package_id: number;
  description: string;
  current_url: string;
  promo_code?: string;
}

export const createTariff = async (data: createTariffRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  const response = await axiosInstanceV2.post<createTariffResponseDto>(
    PAYMENTS_API_URL.createTariff(),
    data,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );

  return response.data;
};
